/** Small date/time helpers for calm, human-friendly display. Local timezone. */

export function greetingByHour(now = new Date()): string {
  const h = now.getHours();
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
}

function startOfDay(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

/** "Today", "Yesterday", a weekday for the last week, else a short date. */
export function relativeDay(iso: string, now = new Date()): string {
  const then = new Date(iso);
  const dayMs = 86_400_000;
  const diffDays = Math.round((startOfDay(now) - startOfDay(then)) / dayMs);
  if (diffDays <= 0) return "Today";
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7) return then.toLocaleDateString(undefined, { weekday: "short" });
  return then.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

/** "Jul 8" — short month + day, from an ISO date or datetime (local). */
export function shortDate(iso: string): string {
  const d = iso.length <= 10 ? new Date(`${iso}T00:00:00`) : new Date(iso);
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function timeOfDay(iso: string): string {
  return new Date(iso).toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });
}

/** "Today · 8:41 PM" */
export function entryWhen(iso: string, now = new Date()): string {
  return `${relativeDay(iso, now)} · ${timeOfDay(iso)}`;
}
